import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button, DrawerEntityCard } from '@aimsos/ui';

import { ExternalLink, FileText, Link2 } from 'lucide-react';

const openExternally = (url) => window.open(url, '_blank', 'noopener,noreferrer');

/**
 * The files and URLs attached to a note (CT-5528), as `DrawerEntityCard` rows.
 *
 * A document lives in the drive, so it is shown by name; a URL is opened in a
 * new tab through a `Button` rather than a raw anchor. Renders nothing when
 * there are no links — an empty "Links" heading is chrome with nothing behind it.
 */
const NoteLinks = memo(function NoteLinks({ links }) {
  const { t } = useTranslation('unified-profiles');
  if (!links?.length) return null;

  return (
    <section aria-label={t('notes.links.title')} className="flex flex-col gap-2" data-testid="note-links">
      <h3 className="text-xs font-semibold uppercase tracking-wide text-content-muted">{t('notes.links.title')}</h3>
      {links.map((link) => {
        const isDocument = link.kind === 'document';
        return (
          <DrawerEntityCard
            key={link.id}
            size="sm"
            variant="neutral"
            icon={isDocument ? FileText : Link2}
            label={t(isDocument ? 'notes.links.document' : 'notes.links.url')}
            value={link.label}
          >
            {isDocument ? null : (
              <Button
                variant="ghost"
                size="sm"
                rightIcon={ExternalLink}
                onClick={() => openExternally(link.url)}
              >
                {t('notes.links.open')}
              </Button>
            )}
          </DrawerEntityCard>
        );
      })}
    </section>
  );
});

export default NoteLinks;
